import { render, staticRenderFns } from "./MainSectionPrEc.vue?vue&type=template&id=3194076c"
import script from "./MainSectionPrEc.vue?vue&type=script&lang=js"
export * from "./MainSectionPrEc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports